// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__Pw5fy","large":"styles_large__3jCkd"};